import bbitApi from '@api/make-request'
import {
  IPathParamsArgs,
  IRepository,
  numberArgs,
} from '@api/repositories/i-repository'
import { IInstitutionSchedule } from '@app/interfaces/organization/institution-schedule'
import { resolveParams } from '@app/utils/resolve-params/resolve-params'
import { AxiosResponse } from 'axios'

class InstitutionSchedulesRepository
  implements IRepository<IInstitutionSchedule>
{
  create(
    data: IInstitutionSchedule,
  ): Promise<AxiosResponse<IInstitutionSchedule>> {
    return bbitApi.post('/dictionary/api/v1/institution-schedule', data)
  }

  getAll(
    args: IPathParamsArgs,
  ): Promise<AxiosResponse<IInstitutionSchedule[]>> {
    return bbitApi.get('/dictionary/api/v1/institution-schedule', {
      cancelToken: args.source?.token,
      params: resolveParams(args),
    })
  }

  getOne(args: numberArgs): Promise<AxiosResponse<IInstitutionSchedule>> {
    return bbitApi.get(`/dictionary/api/v1/institution-schedule/${args.data}`, {
      cancelToken: args.source?.token,
    })
  }

  update(
    data: IInstitutionSchedule,
  ): Promise<AxiosResponse<IInstitutionSchedule>> {
    return bbitApi.put(
      `/dictionary/api/v1/institution-schedule/${data.id}`,
      data,
    )
  }
}

export default new InstitutionSchedulesRepository()
